var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightAsRepRoasting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 27,
    viewBox: "0 0 41 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7245 14.4238C38.3235 14.8248 38.1225 15.3118 38.1225 15.8848C38.1225 16.4578 38.3235 16.9448 38.7245 17.3458C39.1255 17.7468 39.6125 17.9468 40.1855 17.9468V22.0718C40.1855 22.6458 39.9845 23.1318 39.5835 23.5328C39.1825 23.9348 38.6955 24.1348 38.1225 24.1348H17.4975C16.9245 24.1348 16.4375 23.9348 16.0375 23.5328C15.6355 23.1318 15.4355 22.6458 15.4355 22.0718V17.9468C16.0085 17.9468 16.4955 17.7468 16.8965 17.3458C17.2975 16.9448 17.4975 16.4578 17.4975 15.8848C17.4975 15.3118 17.2975 14.8248 16.8965 14.4238C16.4955 14.0228 16.0085 13.8218 15.4355 13.8218V9.69677C15.4355 9.12477 15.6355 8.63777 16.0375 8.23677C16.4375 7.83577 16.9245 7.63477 17.4975 7.63477H38.1225C38.6955 7.63477 39.1825 7.83577 39.5835 8.23677C39.9845 8.63777 40.1855 9.12477 40.1855 9.69677V13.8218C39.6125 13.8218 39.1255 14.0228 38.7245 14.4238Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9984 7.63477V9.13477",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9984 11.8315V21.2695",
    stroke: "white",
    strokeWidth: 1.5,
    strokeDasharray: "2.7 2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9984 22.6182V24.1182",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03332 12.9319C1.97089 11.0794 3.67684 9.16883 2.56319 6.88127C3.75398 7.23109 4.87087 8.04358 5.72403 10.5083C7.3738 7.50022 8.53606 4.75121 7.87343 0.544434C9.11021 1.87666 10.3814 2.68123 11.6533 3.47755C13.6913 4.7537 15.4207 6.03118 16.6994 8.13754C17.839 10.0149 18.4197 12.1688 18.6203 14.5104C19.0352 13.7204 20.0946 13.0879 20.3905 11.1753C23.1198 16.4996 21.498 22.2695 16.1743 24.6061L11.7582 26.5444C12.4077 25.8504 13.0298 25.1217 13.4523 24.3075C14.9822 21.3592 13.7947 17.3846 10.5838 14.6157C10.6581 15.8767 10.3297 16.7026 9.86285 17.3791C9.20997 18.3251 8.4753 19.0876 7.98204 19.9541C6.79356 22.0423 7.65456 24.5946 9.13505 26.3577L4.82794 24.3843C0.475993 22.3901 -1.14161 17.2291 1.03332 12.9319Z",
    fill: "#368FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightAsRepRoasting);
export default __webpack_public_path__ + "static/media/light_as_rep_roasting.5a8ea9d0668d1e1272fee9d134b16eb4.svg";
export { ForwardRef as ReactComponent };